/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListOrganizationRemoteSessionClientsResult,
  ListOrganizationRemoteSessionClientsResult$inboundSchema,
} from "../components/listorganizationremotesessionclientsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListOrganizationRemoteSessionClientsSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type ListOrganizationRemoteSessionClientsRequest = {
  /**
   * The remote_session_issuer id to list clients for.
   */
  issuerId: string;
  /**
   * Pagination cursor.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

export type ListOrganizationRemoteSessionClientsResponse = {
  result: ListOrganizationRemoteSessionClientsResult;
};

/** @internal */
export type ListOrganizationRemoteSessionClientsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionClientsSecurity$outboundSchema:
  z.ZodMiniType<
    ListOrganizationRemoteSessionClientsSecurity$Outbound,
    ListOrganizationRemoteSessionClientsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function listOrganizationRemoteSessionClientsSecurityToJSON(
  listOrganizationRemoteSessionClientsSecurity:
    ListOrganizationRemoteSessionClientsSecurity,
): string {
  return JSON.stringify(
    ListOrganizationRemoteSessionClientsSecurity$outboundSchema.parse(
      listOrganizationRemoteSessionClientsSecurity,
    ),
  );
}

/** @internal */
export type ListOrganizationRemoteSessionClientsRequest$Outbound = {
  issuer_id: string;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionClientsRequest$outboundSchema:
  z.ZodMiniType<
    ListOrganizationRemoteSessionClientsRequest$Outbound,
    ListOrganizationRemoteSessionClientsRequest
  > = z.pipe(
    z.object({
      issuerId: z.string(),
      cursor: z.optional(z.string()),
      limit: z.optional(z.int()),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        issuerId: "issuer_id",
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function listOrganizationRemoteSessionClientsRequestToJSON(
  listOrganizationRemoteSessionClientsRequest:
    ListOrganizationRemoteSessionClientsRequest,
): string {
  return JSON.stringify(
    ListOrganizationRemoteSessionClientsRequest$outboundSchema.parse(
      listOrganizationRemoteSessionClientsRequest,
    ),
  );
}

/** @internal */
export const ListOrganizationRemoteSessionClientsResponse$inboundSchema:
  z.ZodMiniType<ListOrganizationRemoteSessionClientsResponse, unknown> = z.pipe(
    z.object({
      Result: ListOrganizationRemoteSessionClientsResult$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "Result": "result",
      });
    }),
  );

export function listOrganizationRemoteSessionClientsResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  ListOrganizationRemoteSessionClientsResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListOrganizationRemoteSessionClientsResponse$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListOrganizationRemoteSessionClientsResponse' from JSON`,
  );
}
